<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <div
    data-slot="dialog-footer"
    :class="
      cn('flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', props.class)
    "
  >
    <slot />
  </div>
</template>
